export const storeProducts = [
  {
    id: 1,
    title: "Apple iPhone 13 Pro",
    img: "img/product-1.png",
    price: 1099,
    company: "Apple",
    info:
      "The new iPhone 13 Pro and iPhone 13 Pro Max “ProMotion” is Apple speak for a high refresh rate display. On the iPhone 13 Pro and iPhone 13 Pro Max it can go as low as 10Hz and as high as 120Hz. iOS has been reworked to make the best use of the new display.The choice of display sizes is the same – a 6.1” iPhone 13 Pro or a 6.7” Pro Max. The notch that hosts the TrueDepth camera is now 20% smaller, while the new panels are up to 25% brighter outdoors.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 2,
    title: "Samsung Galaxy S21",
    img: "img/product-2.png",
    price: 887,
    company: "SAMSUNG",
    info:
      "The Galaxy S21 has a 6.2-inch full-HD+ display with a 120Hz refresh rate.. It has Corning Gorilla Glass Victus on the display and a metal frame but the back is made out of plastic. The smartphone packs in a 4000mAh battery and does not get a charger in the box. The Galaxy S21 is powered by the Exynos 2100 5G SoC and gets 8GB of RAM. You can choose between 128GB and 256GB of storage but it isn’t expandable. You get Android 11 out of the box with Samsung's One UI 3.0 on top. The Galaxy S21 offers good performance but the smaller battery capacity doesn’t let it last as long as the Galaxy S21+. There is a triple camera setup with a 12-megapixel ultra-wide angle camera, a 12-megapixel wide-angle camera, and a 64-megapixel telephoto camera. For selfies, it has a 10-megapixel front camera. Camera performance of the Galaxy S21 is impressive in different lighting conditions and will not disappoint you. The small battery and the polycarbonate back are the only major cons for this smartphone.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 3,
    title: "Microsoft Surface Go 3",
    img: "img/product-3.png",
    price: 485,
    company: "Microsoft",
    info:
      "The Surface Go 3 is Microsoft's latest and most affordable tablet, and it's designed to tackle basic computing tasks. While there's no dearth of convertible Windows laptops, detachable 2-in-1s are still a rarity and usually cost a premium. This makes the Surface Go 3 quite interesting as it's priced lower than the Surface Pro line. It's also a lot more portable, hence the name. The Microsoft Surface Go 3 is primarily a Windows tablet, which can transform into a laptop with the optional keyboard attachment. Think of it as Microsoft's version of an iPad, but running the full desktop Windows experience you're probably used to. It could be an appealing solution for anyone looking for a hybrid computer that can fulfil both work and entertainment needs, such as content consumption. Is the Surface Go worth it though? Let's find out.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 4,
    title: "Apple 13.3 inches MacBook Air",
    img: "img/product-4.png",
    price: 729,
    company: "Apple",
    info:
      "Apple MacBook Air 2020 is a macOS laptop with a 13.30-inch display that has a resolution of 2560x1600 pixels. It is powered by a Core i3 processor and it comes with 8GB of RAM. The Apple MacBook Air 2020 packs 256GB of SSD storage. Graphics are powered by Integrated Graphics Processor.Model: MacBook Air 2020 Battery Life (up to hours): 11 Operating system: macOS",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 5,
    title: "Apple Watch Series 6",
    img: "img/product-5.png",
    price: 349,
    company: "Apple",
    info:
      "The Series 6 has all the excellent health, safety, and lifestyle features of its predecessor. These include ECG readings, high and low heart rate notifications, irregular heart rhythm notifications, menstrual cycle tracking, fall detection, high decibel alerts, emergency SOS, and international emergency calling.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 6,
    title: "Amazon Echo Dot",
    img: "img/product-6.jpg",
    price: 75,
    company: "Amazon",
    info:
      "The Amazon Echo Dot is a hockey puck-shaped smart speaker and a more compact version of the original Amazon Echo. You can use voice commands on an Amazon Echo Dot through an Alexa personal assistant to answer questions, play the news, play music, and hundreds of other tasks.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 7,
    title: "Iphone 7",
    img: "img/product-7.png",
    price: 215,
    company: "Apple",
    info:
      "Apple iPhone 7 mobile was launched in September 2016. The phone comes with a 4.70-inch touchscreen display with a resolution of 750x1334 pixels at a pixel density of 326 pixels per inch (ppi) and an aspect ratio of 16:9. Apple iPhone 7 is powered by a 2.34GHz quad-core Apple A10 Fusion processor. It comes with 2GB of RAM. The Apple iPhone 7 runs iOS 10 and is powered by a 1960mAh non-removable battery.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 8,
    title: "Apple AirPods Max",
    img: "img/product-8.jpg",
    price: 502,
    company: "Apple",
    info:
      "The Apple AirPods Max is the most expensive audio product in Apple's lineup, and not without good reason. This is a beautiful, comfortable, and luxurious pair of headphones, and works incredibly well with Apple smartphones, tablets, and computers. Priced at dollars. 504,000, the Apple AirPods Max is no doubt expensive, especially when compared to products such as the Sony WH-1000XM4 and Bose Noise Cancelling Headphones 700. However, for an Apple fan, this is the pinnacle of wireless audio.",
    inCart: false,
    count: 0,
    total: 0
  }
];

export const detailProduct = {
  id: 1,
  title: "Google Pixel - Black",
  img: "img/product-1.png",
  price: 10,
  company: "google",
  info:
    "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
  inCart: false,
  count: 0,
  total: 0
};
